import { ChangeEventHandler, FocusEventHandler, forwardRef } from "react";
import styles from "./NumberInput.module.scss";
import InputWrapper, { InputWrapperProps } from "../InputWrapper/InputWrapper";

type NumberInputProps = {
  max?: number;
  min?: number;
  value?: string;
  placeholder?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  disabled?: boolean;
} & Omit<InputWrapperProps, "children" | "inputRef">;

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  function NumberInput(
    {
      className,
      leftSection,
      rightSection,
      onChange,
      onBlur,
      value,
      placeholder,
      disabled,
      loading,
      loadingMessage,
      size,
      unstyled,
      max,
      min,
    },
    ref,
  ) {
    return (
      <InputWrapper
        className={className}
        leftSection={leftSection}
        rightSection={rightSection}
        disabled={disabled}
        size={size}
        unstyled={unstyled}
        loading={loading}
        loadingMessage={loadingMessage}
      >
        <input
          ref={ref}
          className={styles.input}
          type="number"
          onChange={onChange}
          onBlur={onBlur}
          value={loading ? undefined : value}
          placeholder={placeholder}
          disabled={disabled}
          max={max}
          min={min}
        />
      </InputWrapper>
    );
  },
);

export default NumberInput;
